<div class="meter">
  <span class="meter__ruler" aria-hidden="true">
    @for (fill of parts.fills; track $index) {
      <span class="meter__part" [style.--per]="parts.perPart">
        <span class="meter__fill" [style.--fill]="fill"></span>
      </span>
    }
  </span>

  <!-- Not a live region: it changes with every keystroke. The hidden line
       below announces only a new part count or a change of encoding. -->
  <p class="meter__caption">
    <span>{{ lengthLabel }}</span>
    <span class="meter__sep" aria-hidden="true">·</span>
    <span>{{ partsLabel }}</span>
    <span class="meter__sep" aria-hidden="true">·</span>
    <span>{{ parts.encoding }}</span>
    @if (parts.parts) {
      <span class="meter__room">
        {{ roomLeft }} {{ roomLeft === 1 ? "character" : "characters" }} left before part {{ parts.parts + 1 }}
      </span>
    }
  </p>

  <span class="bk-sr-only" aria-live="polite">{{ announcement }}</span>

  @if (encodingNote) {
    <p class="meter__note">
      <strong>{{ encodingNote }}.</strong>
      Each part holds {{ unicodeRoom.now }} characters instead of {{ unicodeRoom.plain }}. Swap it for a plain character to fit
      more in each part.
    </p>
  }
  @if (parts.estimated) {
    <p class="meter__note">
      Personalised fields are counted as 8 characters each, so the length and parts are estimates. Long names can add a
      part.
    </p>
  }
</div>
